/* global axios */
import ApiClient from './ApiClient';

class CommercialReportsAPI extends ApiClient {
  constructor() {
    super('commercial_reports', { accountScoped: true });
  }

  show(params = {}) {
    const query = new URLSearchParams(
      Object.entries(params).filter(
        ([, value]) => value !== '' && value != null
      )
    ).toString();
    return axios.get(`${this.url}${query ? `?${query}` : ''}`);
  }
}

export default new CommercialReportsAPI();
